import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import './profile.css';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    if (!user) {
      navigate('/');
      return;
    }

    // Fetch fresh user info from API to get picture
    fetchCurrentUser();
  }, [user, navigate]);

  const fetchCurrentUser = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
      const response = await fetch(`${API_URL}/api/auth/me/`, {
        headers: {
          'Authorization': `Bearer ${user?.accessToken || localStorage.getItem('access_token')}`,
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setUserInfo(data);
      }
    } catch (error) {
      console.error('Failed to fetch current user:', error);
      // Fallback to stored user object
      if (user?.user) {
        setUserInfo(user.user);
      }
    }
  };

  if (!user || !userInfo) {
    return (
      <div className="profile-container">
        <div className="profile-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="profile-container">
      <div className="profile-header">
        <div className="profile-header-content">
          <img 
            src={userInfo.picture || 'https://via.placeholder.com/80x80/039772/ffffff?text=' + (userInfo.first_name?.charAt(0) || 'U')} 
            alt="Profile" 
            className="profile-picture-large"
          />
          <div className="profile-header-info">
            <h1>{userInfo.first_name} {userInfo.last_name}</h1>
            <p className="profile-email">{userInfo.email}</p>
          </div>
        </div>
      </div>

      <div className="profile-content">
        <div className="profile-sidebar">
          <nav className="profile-nav">
            <Link 
              to="/profile" 
              className={location.pathname === '/profile' ? 'profile-nav-link active' : 'profile-nav-link'}
            >
              Profile Information
            </Link>
            <Link 
              to="/profile/settings" 
              className={location.pathname === '/profile/settings' ? 'profile-nav-link active' : 'profile-nav-link'}
            >
              Settings
            </Link>
          </nav>
        </div>

        <div className="profile-main">
          {location.pathname === '/profile' && (
            <div className="profile-section">
              <h2>Profile Information</h2>
              <div className="profile-info-grid">
                <div className="profile-info-item">
                  <label>First Name</label>
                  <p>{userInfo.first_name || 'N/A'}</p>
                </div>
                <div className="profile-info-item">
                  <label>Last Name</label>
                  <p>{userInfo.last_name || 'N/A'}</p>
                </div>
                <div className="profile-info-item">
                  <label>Email</label>
                  <p>{userInfo.email}</p>
                </div>
                <div className="profile-info-item">
                  <label>User ID</label>
                  <p>{userInfo.id}</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;

